import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BarChart3, Calendar, ChevronDown, ClipboardList, Flame, Gauge, Quote, Users } from 'lucide-react';
import { Seo } from '../components/Seo';
import { BUSINESS, SEASON } from '../data/site';
import { GROUP_PROGRAMS, SPEED_SCHOOL } from '../data/programs';
type Testimonial = {
  quote: string;
  name: string;
  role: string;
};
const TESTIMONIALS: Testimonial[] = [{
  quote: 'My son added 4 inches to his vertical and cut his 40 time in one summer. The testing every month shows him the work is paying off, and he wants to be in the gym.',
  name: 'Marcus T.',
  role: 'Parent · Varsity Football · Prosper HS'
}, {
  quote: 'Came home from D1 ball needing to clean up my mechanics and add real speed. Fernando built a plan around my position and my off-season. I came back to campus stronger and faster, on paper.',
  name: 'Tyler M.',
  role: 'D1 Baseball · Allen, TX'
}];
const FAQS = [{
  question: 'What if my athlete has never trained before?',
  answer: 'That is a normal starting point. Every athlete begins with a free athlete evaluation, and coaching starts with mechanics before load is added.'
}, {
  question: 'What if my athlete misses a session?',
  answer: 'Every monthly enrollment includes one free make-up per month in an age-appropriate session, subject to availability.'
}, {
  question: 'Do you offer a sibling discount?',
  answer: 'Additional siblings receive 10% off their monthly plan.'
}];
export function Home() {
  return <div className="w-full bg-white" data-id="element-613" data-mp="2895jz3rcqkqk">
      <Seo title="Sports Performance Training in McKinney, TX | Reach Performance" description="Small-group speed and strength training for high school and homeschool athletes in McKinney, TX. Fall season starts September 1. Free athlete evaluation to start." path="/" data-id="element-614" data-mp="28617zk7nakpc" />
      <Hero data-id="element-615" data-mp="1uap52pjc5nxc" />
      <ServiceAreaStrip data-id="element-616" data-mp="1kkqnlgkg8gf0" />
      <ProgramsPreview data-id="element-617" data-mp="1kkh6kihdtjlg" />
      <WhyReach data-id="element-618" data-mp="1kjxl4rsiwd2o" />
      <Testimonials data-id="element-619" data-mp="1kjfmjoie1mrl" />
      <HowItWorks data-id="element-620" data-mp="1omc73krhnsy6" />
      <FAQPreview data-id="element-621" data-mp="1omu10aqohv2x" />
      <FinalCta data-id="element-622" data-mp="1ondi5p8i8ffw" />
    </div>;
}
function Hero() {
  return <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden bg-reach-black pb-24 pt-32 md:pb-28 md:pt-40" data-id="element-623" data-mp="1amjax9x70kit">
      <div className="absolute inset-0" data-id="element-624" data-mp="1fmfghdljgk0h">
        <img src="https://cdn.magicpatterns.com/uploads/rgLqfeYbfsME5fh7JYem7K/_DSC2694_2.jpg" alt="Reach Performance athletes training at INPOWERiQ in McKinney" className="h-full w-full object-cover object-center" style={{
        filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
      }} data-id="element-625" data-mp="23b8c18y90puk" />
        <div className="absolute inset-0 bg-black/70" data-id="element-626" data-mp="1yjq9whkhoj80" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-627" data-mp="1yi5gwwdtp8c9" />
      </div>

      <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-628" data-mp="2m89hsvzmmtzk">
        <div className="absolute top-1/3 -left-40 h-2 w-[60%] -rotate-[8deg] bg-reach-red opacity-60" data-id="element-629" data-mp="2r241w0j59az6" />
        <div className="absolute top-[42%] -left-40 h-2 w-[45%] -rotate-[8deg] bg-reach-red opacity-40" data-id="element-630" data-mp="fjzdfeu9zu8z" />
        <div className="absolute top-[50%] -left-40 h-2 w-[30%] -rotate-[8deg] bg-reach-red opacity-30" data-id="element-631" data-mp="akmtp2ypb3am" />
      </div>

      <div className="relative z-10 mx-auto max-w-container px-4 text-center md:px-8" data-id="element-632" data-mp="kcis6f4p8vfd">
        <p className="mb-5 font-inter text-sm font-semibold uppercase tracking-[0.25em] text-reach-red-light md:text-base" data-id="element-633" data-mp="kewo0q77ebnz">
          Fall Season · {SEASON.range}
        </p>
        <h1 className="mx-auto mb-6 max-w-4xl font-bebas text-[46px] leading-[0.95] tracking-wide text-white sm:text-6xl md:text-7xl lg:text-[84px]" data-id="element-634" data-mp="3nv3q4s9z00un">
          Sports Performance Training in McKinney, TX
        </h1>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-base text-white md:text-xl" data-id="element-635" data-mp="qnsc66gbnjq">
          Small-group speed and strength coaching for high school and homeschool athletes.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-636" data-mp="1c5t0vqt9kgb9">
          <Link to="/book" className="btn-primary sm:w-auto" data-id="element-637" data-mp="2ccq2yu9wrs4d">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/fall-2026" className="btn-secondary-dark sm:w-auto" data-id="element-638" data-mp="2hb19av0zvkhu">
            See Fall 2026 Schedule
          </Link>
        </div>
      </div>
    </section>;
}
function ServiceAreaStrip() {
  return <section className="bg-reach-red" data-id="element-639" data-mp="2qbzevhr3002j">
      <p className="px-4 py-3 text-center font-inter text-[10px] font-semibold uppercase tracking-[0.22em] text-white sm:text-xs" data-id="element-640" data-mp="2qaworc1l21no">
        Training athletes from {BUSINESS.areaServed.join(' · ')}
      </p>
    </section>;
}
function ProgramsPreview() {
  return <section className="bg-white py-20 md:py-28" data-id="element-641" data-mp="3513yn3diyccr">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-642" data-mp="3a102n2m823sb">
        <div className="mb-12 text-center" data-id="element-643" data-mp="3a2kweq0ppip4">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-644" data-mp="3e1tqxx3ktklq">
            Fall 2026 Programs
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-645" data-mp="12gb38c1ccasb">Find Your Group</h2>
          <p className="mx-auto mt-4 max-w-2xl font-inter text-base text-reach-black/70 md:text-lg" data-id="element-646" data-mp="ybtmymu6wfma">
            Two ongoing groups plus a two-Saturday Speed School. Every athlete starts with a free
            evaluation.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-647" data-mp="1m2phhrq15ox8">
          {GROUP_PROGRAMS.map(program => <article key={program.id} className="flex flex-col border-b-4 border-transparent bg-reach-black p-7 text-white transition-colors duration-200 hover:border-reach-red" data-id="element-648" data-mp="1h3mdmalsdoqu">
              <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.22em] text-reach-red-light" data-id="element-649" data-mp="17d9v0nxj85nc">
                {program.eyebrow}
              </p>
              <h3 className="mb-5 font-bebas text-3xl leading-none tracking-wide" data-id="element-650" data-mp="2028h1w4rzrxx">
                {program.title}
              </h3>
              <ul className="mb-5 space-y-2" data-id="element-651" data-mp="3ubvtmkrpwg7r">
                {program.slots.map(slot => <li key={`${slot.days}-${slot.time}`} className="font-inter text-base text-white" data-id="element-652" data-mp="25i6qnt4advz">
                    <span className="font-semibold" data-id="element-653" data-mp="3kjzoipr7rpu1">{slot.days}</span>
                    <span className="text-white/80" data-id="element-654" data-mp="3pjcg1nt15l2y"> · {slot.time}</span>
                  </li>)}
              </ul>
              <p className="mt-auto border-t border-white/15 pt-5 font-inter text-sm uppercase tracking-[0.18em] text-white/75" data-id="element-655" data-mp="3al1uj7b0r43n">
                {program.cap}
              </p>
            </article>)}

          <article className="flex flex-col border-b-4 border-transparent bg-reach-gray p-7 transition-colors duration-200 hover:border-reach-red" data-id="element-656" data-mp="31nrj9ly7beyq">
            <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.22em] text-reach-red" data-id="element-657" data-mp="zu0nl08l6h0x">
              Saturdays · September 12 + 26
            </p>
            <h3 className="mb-5 font-bebas text-3xl leading-none tracking-wide" data-id="element-658" data-mp="14rall4a1k10d">Speed School</h3>
            <p className="mb-5 font-inter text-base leading-relaxed text-reach-black/80" data-id="element-659" data-mp="1ev7ge82kqdlx">
              Coached sprint training plus speed and force plate testing. {SPEED_SCHOOL.bothSessions},{' '}
              {SPEED_SCHOOL.dropIn}.
            </p>
            <Link to="/speed-school" className="mt-auto inline-flex items-center gap-2 font-inter text-sm font-semibold uppercase tracking-wider text-reach-black transition-colors hover:text-reach-red" data-id="element-660" data-mp="1iy43oc326xw7">
              See Speed School details
              <ArrowRight size={16} aria-hidden="true" data-id="element-661" data-mp="26p9g0h9sj81r" />
            </Link>
          </article>
        </div>

        <div className="mt-10 text-center" data-id="element-662" data-mp="22mwek522twas">
          <Link to="/programs" className="btn-secondary" data-id="element-663" data-mp="22l1rak3c1s3j">
            Compare all fall programs
            <ArrowRight size={16} className="ml-2" aria-hidden="true" data-id="element-664" data-mp="cct3iyqeixog" />
          </Link>
        </div>
      </div>
    </section>;
}
function WhyReach() {
  const pillars = [{
    Icon: Calendar,
    title: 'Periodized Programming',
    body: 'Every day has a purpose. No random workouts.'
  }, {
    Icon: Gauge,
    title: 'Force Plate Testing',
    body: 'Jump and landing output measured, not guessed.'
  }, {
    Icon: BarChart3,
    title: 'Testing Every 4 Weeks',
    body: 'Speed gates and the same markers all season.'
  }, {
    Icon: Users,
    title: 'Capped At 10 Athletes',
    body: 'Small groups so every athlete gets coached.'
  }];
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-665" data-mp="iw508enri851">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-666" data-mp="mv46q3p56cyl">
        <div className="mb-14 text-center" data-id="element-667" data-mp="ruqevyq4530j">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-668" data-mp="rwjo9ls421c8">
            What Makes Us Different
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-5xl" data-id="element-669" data-mp="239m60k5y4wxz">Why Reach</h2>
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10" data-id="element-670" data-mp="2delsvz7jfi11">
          {pillars.map(({
          Icon,
          title,
          body
        }) => <article key={title} className="text-center" data-id="element-671" data-mp="28fixl6hd0q69">
              <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-[4px] bg-reach-black" data-id="element-672" data-mp="23nr2cin9dw9s">
                <Icon size={28} className="text-reach-red-light" aria-hidden="true" data-id="element-673" data-mp="1zlmg44z541x6" />
              </div>
              <h3 className="mb-3 font-bebas text-2xl tracking-wide" data-id="element-674" data-mp="1uodufues9fr6">{title}</h3>
              <p className="font-inter text-base leading-relaxed text-reach-black/80" data-id="element-675" data-mp="1po888tra8lgh">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}
function Testimonials() {
  return <section className="relative overflow-hidden bg-reach-black py-20 md:py-28" data-id="element-676" data-mp="1goux7wnifotn">
      <div className="absolute top-0 -left-20 h-1 w-[40%] rotate-[3deg] bg-reach-red opacity-50" data-id="element-677" data-mp="3f3xuiw55kjun" />
      <div className="absolute bottom-0 -right-20 h-1 w-[40%] rotate-[3deg] bg-reach-red opacity-50" data-id="element-678" data-mp="3b1ay0hxjear4" />
      <div className="relative mx-auto max-w-container px-4 md:px-8" data-id="element-679" data-mp="cntog8dnh66y">
        <div className="mb-12 text-center" data-id="element-680" data-mp="8mzy78cqjfaw">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red-light" data-id="element-681" data-mp="8m82zyn1vjl5">
            From The Families We Train
          </p>
          <h2 className="font-bebas text-4xl leading-none tracking-wide text-white md:text-6xl" data-id="element-682" data-mp="hnxvz8wkyql1">
            Real Athletes. Real Results.
          </h2>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-683" data-mp="3q1evpdww3xqm">
          {TESTIMONIALS.map(testimonial => <article key={testimonial.name} className="flex flex-col border border-white/10 bg-white/[0.04] p-7 md:p-9" data-id="element-684" data-mp="3nn3y2jjb5ya">
              <Quote size={32} className="mb-4 shrink-0 text-reach-red-light" aria-hidden="true" data-id="element-685" data-mp="3v0hpg27f6hja" />
              <p className="mb-7 font-inter text-base leading-relaxed text-white md:text-lg" data-id="element-686" data-mp="37ax5bfzj5e8f">
                &quot;{testimonial.quote}&quot;
              </p>
              <div className="mt-auto border-t border-white/10 pt-5" data-id="element-687" data-mp="1hutip24498a5">
                <p className="mb-1 font-bebas text-lg leading-none tracking-wider text-white" data-id="element-688" data-mp="1mmb8cu0ovmft">
                  {testimonial.name}
                </p>
                <p className="font-inter text-xs uppercase tracking-[0.2em] text-white/70" data-id="element-689" data-mp="18wrb23pvnhdw">
                  {testimonial.role}
                </p>
              </div>
            </article>)}
        </div>
        <p className="mt-8 text-center font-inter text-xs leading-relaxed text-white/60" data-id="element-690" data-mp="20k9kdsrjf6s5">
          Results vary by athlete, starting point, and adherence.
        </p>
      </div>
    </section>;
}
function HowItWorks() {
  const steps = [{
    number: '01',
    Icon: ClipboardList,
    title: 'Book A Free Athlete Evaluation',
    body: 'We look at how your athlete moves and where the gaps are.'
  }, {
    number: '02',
    Icon: Calendar,
    title: 'Pick The Group That Fits',
    body: 'High school evenings or homeschool daytime blocks.'
  }, {
    number: '03',
    Icon: Flame,
    title: 'Start Training September 1',
    body: 'Then get tested every 4 weeks through December 17.'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-691" data-mp="2d3ws2cbuf121">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-692" data-mp="2d2lpgfu4vzci">
        <div className="mb-14 text-center" data-id="element-693" data-mp="292lb0v71bo5g">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-694" data-mp="2449zmg13d5l4">
            How It Works
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-695" data-mp="1z45luxrkioyl">Get Started In 3 Steps</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8" data-id="element-696" data-mp="1u6m4hozkpw2f">
          {steps.map(({
          number,
          Icon,
          title,
          body
        }) => <article key={number} className="bg-reach-gray p-7 md:p-8" data-id="element-697" data-mp="1q6v7h3jgejpg">
              <div className="mb-5 flex items-center gap-4" data-id="element-698" data-mp="3ojbzyb5lbdbx">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[4px] bg-reach-black" data-id="element-699" data-mp="3ki9zjqzxsv8d">
                  <Icon size={22} className="text-reach-red-light" aria-hidden="true" data-id="element-700" data-mp="169za1dylag1a" />
                </div>
                <span className="font-bebas text-4xl leading-none tracking-wide text-reach-red" data-id="element-701" data-mp="1b8ajvoovwqji">
                  {number}
                </span>
              </div>
              <h3 className="mb-3 font-bebas text-3xl leading-tight tracking-wide" data-id="element-702" data-mp="1k2p0bul5i747">{title}</h3>
              <p className="font-inter text-base leading-relaxed text-reach-black/80" data-id="element-703" data-mp="ncfwpy53mb92">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}
function FAQPreview() {
  const [openQuestion, setOpenQuestion] = useState<number | null>(0);
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-704" data-mp="11bnzf10h01i0">
      <div className="mx-auto max-w-3xl px-4 md:px-8" data-id="element-705" data-mp="11d8viv2fnshz">
        <div className="mb-12 text-center" data-id="element-706" data-mp="27rzzj7murtg8">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-707" data-mp="27r85404zs1rj">
            Parents Ask
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-5xl" data-id="element-708" data-mp="2b9no8tcl29kj">Common Questions</h2>
        </div>
        <div className="space-y-2" data-id="element-709" data-mp="26audh8ookwo2">
          {FAQS.map((faq, index) => {
          const isOpen = openQuestion === index;
          return <article key={faq.question} className="overflow-hidden bg-white" data-id="element-710" data-mp="2kbx0bnni2b01" data-mpi={index}>
                <h3 data-id="element-711" data-mp="2g7pcrtss313e">
                  <button type="button" onClick={() => setOpenQuestion(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-inter text-base font-semibold normal-case tracking-normal text-reach-black transition-colors hover:bg-black/[0.02] md:px-6 md:py-5 md:text-lg" aria-expanded={isOpen} data-id="element-712" data-mp="2g7gvlppmh9me">
                    {faq.question}
                    <ChevronDown size={20} className={`shrink-0 text-reach-red transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-713" data-mp="3czsuaklopot4" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-black/5 px-5 pb-5 pt-4 font-inter text-base leading-relaxed text-reach-black/80 md:px-6 md:pb-6" data-id="element-714" data-mp="dcczc2uy4l3">
                    {faq.answer}
                  </p>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-715" data-mp="3dmgtb83l2wkk">
      <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-716" data-mp="3do1moue5w9gu">
        <h2 className="mb-4 font-bebas text-5xl tracking-wide text-white md:text-7xl" data-id="element-717" data-mp="2yydinleliwpf">
          Ready To Start
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-lg text-white md:text-xl" data-id="element-718" data-mp="33u2ou7l4fbup">
          Every athlete starts with a free evaluation. Groups are capped at 10.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-719" data-mp="2uuxrv5p7jqkn">
          <Link to="/book" className="inline-flex min-h-[44px] items-center justify-center rounded-[4px] bg-white px-6 font-inter text-sm font-semibold uppercase tracking-wide text-reach-black transition-all duration-200 ease-out hover:-translate-y-[3px] hover:bg-reach-black hover:text-white md:min-h-[48px] md:text-base" data-id="element-720" data-mp="voimw09d58vy">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-721" data-mp="1ef9v2yhm6t8r">
            View Training Rates
          </Link>
        </div>
      </div>
    </section>;
}